import React from "react";

// Same looks and sizes as components/button, so a button keeps its place and its colour while it
// loads: no shadow, the spinner in the text colour (white on PRIMARY, gray on SECONDARY).
const BUTTON_COLOR = {
  PRIMARY: "bg-yellow-500 text-white rounded-md",
  SECONDARY: "bg-white text-gray-700 border border-gray-100 rounded-md",
  DEFAULT: "bg-transparent text-gray-700 border border-transparent rounded",
  DISABLED: "bg-gray-50 text-gray-400 border border-gray-300 rounded-md",
};

const BUTTON_SIZE = {
  SM: "text-sm py-2 px-4",
  SMI: "text-sm p-2",
  LG: "h-12 text-base py-3 px-4",
  LGI: "text-sm p-3",
  FULL: "w-full text-lg py-3 px-6",
};

const LoadingButton = ({ color, size, children }) => {
  const colorClassName = BUTTON_COLOR[color || "SECONDARY"];
  const sizeClassName = BUTTON_SIZE[size || "SM"];

  return (
    <button
      type={"button"}
      className={`flex flex-row justify-center items-center gap-2 cursor-wait ${sizeClassName} ${colorClassName}`}
      disabled={true}
      aria-busy="true"
    >
      <svg aria-hidden="true" className="h-5 w-5 animate-spin" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      {children ?? "En cours d'importation"}
    </button>
  );
};

export default LoadingButton;
